import {UserConfig} from '../services/ApiService/types/endpoints';

type Feature =
  | 'subscriptions'
  | 'loans'
  | 'contentLibrary'
  | 'creditbookCheck'
  | 'ibvReport'
  | 'documents';

/**
 * Check if the user has access to a specific feature
 * @param userConfig
 * @param feature
 */
export const checkHasFeatureAccess = (
  userConfig: UserConfig | null,
  feature: Feature,
) => {
  if (!userConfig?.display) {
    return false;
  }
  return userConfig.display[feature];
};
